import {
  TextField,
  Typography,
  SnackbarContent,
  Switch,
  Alert,
  Autocomplete,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import Stack from "@mui/material/Stack";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import DeactivateWebsiteModal from "../EditWebsiteModal/DeactivateWebsiteModal";
// import ReactivateWebsiteModal from "../EditWebsiteModal/ReactivateWebsiteModal";
import { useState } from "react";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { websiteActionEndPointLogic } from "../../../../../../logic/AssetManagement/Websites/websiteActionEndPointLogic";
import {
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../../../../features/userSlice";
import store from "../../../../../../store";
import { useDispatch } from "react-redux";

interface Props {
  getSingleWebsite: any;
  editWebsiteData: any;
  handlechange: any;
  errors: any;
  financeList: any;
  isSyncEnable: any;
  isWebsiteStatus: any;
  oauthTokenHeader: any;
  refreshWebsites: any;
}

function AdditionalInfo({
  getSingleWebsite,
  editWebsiteData,
  handlechange,
  errors,
  financeList,
  isSyncEnable,
  isWebsiteStatus,
  oauthTokenHeader,
  refreshWebsites,
}: Props) {
  const [deactivateWebsite, setdeactivateWebsite] = useState(false);
  // const [reactivateWebsite, setreactivateWebsite] = useState(false);
  const dispatch = useDispatch();

  //-- Set Data on handle input change
  const handleInputChange = (name: string, value: any) => {
    if (name === "g4_property_id") {
      //-- support maximum 10 digits
      if(!/^\d{0,10}$/.test(value)){
          return;
      }
      if (value === "" || value === null) {
        handlechange(name, ""); // Allow clearing the field
        return;
      }
      const intValue = Number(value); // Convert to integer
      if (!isNaN(intValue)) {
        handlechange(name, intValue);
      }
      return;
    }
    handlechange(name, value);
  };

  const handleOpendeactivateWebsite = () => {
    setdeactivateWebsite(true);
  };

  const handleClosedeactivateWebsite = () => {
    setdeactivateWebsite(false);
  };

  //--when swtiching is Sync Enable or disable
  const syncEnableOrDisable = async (syncValue: any) => {
    const data = { sync: syncValue };
    try {
      store.dispatch(setIsLoading(true));
    const res = await websiteActionEndPointLogic.syncEnableOrDisable(
        data,
        getSingleWebsite?.shared_uid,
        oauthTokenHeader
      );
      if (Object.keys(res).length === 0) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: `Website sync data has been successfully ${
            syncValue === "True" ? "enabled" : "disabled"
          }.`,
          type: "success",
        })
      );
    }else{
      throw new Error("In order to enable sync data, please activate the website first.");
    }
    } catch (error: any) {
      const errorMessage =
          typeof error === "string"
            ? error
            : error instanceof Error
            ? error.message
            : "An unexpected error occurred.";
      
        dispatch(setDisplayErrorSnackBar({ message: errorMessage, type: "error" }));
      
        return; // Stop execution, do not close modal
    } finally {
      //-- Refresh Parent Data(Website List Data) After Success
      await refreshWebsites();
      store.dispatch(setIsLoading(false));
    }
  };

  return (
    <>
      <Box>
        <Typography mt={1}>Additional info</Typography>
        <Grid container columnSpacing={{ xs: 2, sm: 2, md: 2 }} mt={2} mb={2}>
          <Grid item xs={12} md={4}>
            <TextField
              id="outlined-multiline-flexible"
              label="G4 Property ID" // Set your label here
              placeholder="How you like the site to be called" // Set your placeholder here
              required
              fullWidth
              error={errors.g4_property_id}
              helperText={errors.g4_property_id}
              name={"g4_property_id"}
              value={editWebsiteData?.g4_property_id}
              onChange={(e) =>
                handleInputChange("g4_property_id", e.target.value)
              }
              color="secondary"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Autocomplete
              fullWidth
              options={
                financeList?.length > 0
                  ? financeList?.map((finance: any) => ({
                      name: finance?.name,
                      id: finance?.id,
                    }))
                  : []
              }
              getOptionLabel={(option: any) => option?.name || ""}
              value={
                financeList?.find(
                  (finance: any) =>
                    finance?.id === editWebsiteData?.finance_activity_id
                ) || null
              }
              onChange={(_, newValue: any) => {
                handleInputChange(
                  "finance_activity_id",
                  newValue?.id || null
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Finance Name"
                  color="secondary"
                  name={"finance_activity_id"}
                  error={errors.finance_activity_id}
                  helperText={errors.finance_activity_id}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              size="small"
            />
          </Grid>
        </Grid>
        <Typography
          sx={{ marginTop: "16px", fontSize: "12px", color: "#00000099" }}
        >
          All fields are mandatory.
        </Typography>
      </Box>
      <Box>
        <Typography mt={1}>Website Status and sync</Typography>
        <SnackbarContent
          sx={{
            background: "#FFF4E5",
            color: "#ED6C02",
            marginTop: "8px",
            boxShadow: "none",
            border: "1px solid #D32F2F80",
            width: "1000px",
          }}
          message={
            <Box display="flex">
              <ErrorOutlineOutlinedIcon
                sx={{ marginRight: "8px", color: "#ED6C02" }}
              />
              <Box>
                <Typography
                  variant="body1"
                  fontWeight="500"
                  sx={{ marginBottom: "4px" }}
                >
                  Please edit the following changes with extreme caution!
                </Typography>
              </Box>
            </Box>
          }
        />
        <Grid container columnSpacing={{ xs: 2, sm: 2, md: 2 }} mt={2} mb={2}>
          <Grid item xs={12} md={2}>
            <Stack
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography>Sync data </Typography>
              <Switch
                disabled={!isSyncEnable}
                checked={getSingleWebsite?.sync_enabled === 1}
                onChange={(e) =>
                  syncEnableOrDisable(e.target.checked ? "True" : "False")
                }
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#2E7D32",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#2E7D32",
                  },
                }}
              />
              <Alert
                variant="outlined"
                severity="success"
                icon={
                  getSingleWebsite?.sync_enabled === 1 ? (
                    <CheckCircleOutlinedIcon
                      sx={{ color: "#1E4620" }}
                      fontSize="small"
                    />
                  ) : (
                    <CancelOutlinedIcon
                      sx={{ color: "#5F2120" }}
                      fontSize="small"
                    />
                  )
                }
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBlock: "8px",
                  padding: "0px 4px",
                  background:
                    getSingleWebsite?.sync_enabled === 1
                      ? "#EDF7ED"
                      : "#FDEDED",
                  width: "120px",
                  border:
                    getSingleWebsite?.sync_enabled === 1
                      ? "1px solid #2E7D3280"
                      : "1px solid #D32F2F80",
                  color:
                    getSingleWebsite?.sync_enabled === 1
                      ? "#1E4620"
                      : "#5F2120",
                }}
              >
                {getSingleWebsite?.sync_enabled === 1 ? "Enabled" : "Disabled"}
              </Alert>
            </Stack>
          </Grid>
          <Grid item xs={12} md={2}>
            <Stack
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography>Website status</Typography>
              <Alert
                variant="outlined"
                severity="success"
                icon={
                  getSingleWebsite?.is_active === 1 ? (
                    <CheckCircleOutlinedIcon
                      sx={{ color: "#1E4620" }}
                      fontSize="small"
                    />
                  ) : (
                    <CancelOutlinedIcon
                      sx={{ color: "#5F2120" }}
                      fontSize="small"
                    />
                  )
                }
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBlock: "8px",
                  padding: "0px 4px",
                  background:
                    getSingleWebsite?.is_active === 1 ? "#EDF7ED" : "#FDEDED",
                  width: "120px",
                  border:
                    getSingleWebsite?.is_active === 1
                      ? "1px solid #2E7D3280"
                      : "1px solid #D32F2F80",
                  color:
                    getSingleWebsite?.is_active === 1 ? "#1E4620" : "#5F2120",
                }}
              >
                {getSingleWebsite?.is_active === 1 ? "Active" : "Inactive"}
              </Alert>
            </Stack>
          </Grid>
          <Grid item xs={12} md={2}>
            <Button
              color="secondary"
              size="large"
              disabled={!isWebsiteStatus}
              onClick={handleOpendeactivateWebsite}
            >
              {getSingleWebsite?.is_active === 1 ? "Deactivate" : "Activate"}{" "}
              website
            </Button>
            {/* <Button
                color="secondary"
                size="large"
                onClick={handleOpenReactivateWebsite}
              >
                reactivate website temporary button
              </Button> */}
          </Grid>
        </Grid>
      </Box>
      <DeactivateWebsiteModal
        open={deactivateWebsite}
        handleClose={handleClosedeactivateWebsite}
        isActive={getSingleWebsite?.is_active}
        websiteShareUid={getSingleWebsite?.shared_uid}
        oauthTokenHeader={oauthTokenHeader}
        refreshWebsites={refreshWebsites}
        website_name={editWebsiteData.ui_site_name}
      ></DeactivateWebsiteModal>
      {/* <ReactivateWebsiteModal
          open={reactivateWebsite}
          handleClose={handleCloseReactivateWebsite}
        ></ReactivateWebsiteModal> */}
    </>
  );
}

export default AdditionalInfo;
